import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Jwt } from '../utilities/constants';
import { HttpClientType } from '../enums/http-client-type.enum';
import { environment } from '../../../environments/environment';

/** Interceptor that adds jwt token to requests */
@Injectable()
export class JwtHttpInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem(Jwt.TOKEN_ID);
    const clientType = request.headers.get('clientType');
    const contentType = request.headers.get('Content-Type');
    const isFormData = request.body instanceof FormData;
    let baseUrl = environment.academyApiUrl;
    if (clientType === HttpClientType.Identity.toString()) {
      baseUrl = environment.idsApiUrl;
    }

    const headers: Record<string, string> = {
      Accept: `application/json`,
    };

    if (contentType) {
      headers['Content-Type'] = contentType;
    } else if (!isFormData) {
      headers['Content-Type'] = `application/json`;
    }

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    if (token) {
      return next.handle(
        request.clone({
          setHeaders: headers,
          url: `${baseUrl}${request.url}`,
        })
      );
    } else {
      return next.handle(
        request.clone({
          setHeaders: headers,
          url: `${baseUrl}${request.url}`,
        })
      );
    }
  }
}
